import { useHistory } from 'react-router-dom';
import LibraryCardButton from '../LibraryCardButtons/LibraryCardButton';
import styles from './LibraryCard.module.scss';
import { LibraryCardProps, UnitCardProps, resolveUnitLanguage } from './cardData';
import { Icon } from '@iconify/react';
import mSStudent from '@iconify-icons/openmoji/man-student-medium-light-skin-tone';
import lockAlt from '@iconify-icons/bx/lock-alt';

type Props = LibraryCardProps & UnitCardProps & { isUnavailable?: boolean };

const MiddleSchoolLibraryCard = ({
  isShow,
  displayName,
  subtitle,
  content,
  isLocked,
  isWrongGrade,
  isUnavailable,
  unit,
  featuredImage,
  percentComplete,
  classroom,
  gradeSpan,
}: Props): JSX.Element => {
  const history = useHistory();
  const handleClick = () => {
    history.push(`/lessonPlan/${unit}/${resolveUnitLanguage(unit, classroom.language)}/${classroom.grade}`);
  };
  let buttonText = '';
  if (percentComplete === 0) buttonText = 'Explore';
  if (percentComplete === 100) buttonText = 'Complete';
  if (percentComplete !== 100 && percentComplete !== 0) buttonText = 'Resume';

  return isShow ? (
    <div className={styles.container}>
      <div className={styles.imgContainer}>
        {isWrongGrade && (
          <div className={styles.wrongGrade}>
            <Icon icon={mSStudent} width={60} />
            Requires Different Grade Level
          </div>
        )}
        {!isWrongGrade && (
          <img
            className={
              gradeSpan && gradeSpan.includes(9)
                ? styles.highSchoolLibraryCardThumbnail
                : styles.middleSchoolLibraryCardThumbnail
            }
            src={featuredImage}
            alt={displayName}
            onClick={isUnavailable ? undefined : handleClick}
            style={isUnavailable ? { cursor: 'default' } : undefined}
          />
        )}
        {isUnavailable && !isWrongGrade && (
          <div className={styles.locked}>
            <Icon icon={lockAlt} width={40} />
          </div>
        )}
        {isLocked && !isUnavailable && !isWrongGrade && (
          <div className={styles.locked}>
            Limited content...Upgrade for full access
            <span className={styles.upgrade} onClick={() => history.push('/activatetrial')}>
              Upgrade Now
            </span>
          </div>
        )}
      </div>

      <div className={styles.textContainer}>
        <h3 className={styles.typeHeading}>{subtitle && subtitle}</h3>
        <h2 className={styles.unitTitle}>{displayName && displayName}</h2>
        <p>{content}</p>
        <div className={styles.buttonRow}>
          <>
            {isWrongGrade && !isLocked && (
              <p>
                Please switch to a {gradeSpan && gradeSpan.includes(9) ? 'High School' : 'Middle School'} class using
                the menu bar to access this content
              </p>
            )}
            {!isWrongGrade && !isUnavailable && (
              <>
                <LibraryCardButton buttonText={buttonText} handleClick={handleClick} />
                {buttonText === 'Resume' && (
                  <div className={styles.completion}>
                    <span className={styles.completionValue}>{percentComplete}</span>% Complete
                  </div>
                )}
              </>
            )}
          </>
        </div>
        {/* {isLocked && <div className={styles.lockFill} />} */}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default MiddleSchoolLibraryCard;
